import React from 'react'
import BlogDetailsContainer from '../../../../Components/Miscellaneous/Blog/BlogDetails'

export default function BlogDetails() {
  return (
    <div className='page-body'>
        <BlogDetailsContainer/>
    </div>
  )
}
